import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantFieldGroupTemplate } from '../mutations/deleteParticipantFieldGroupTemplate.mutation';
import type {
  DeleteParticipantFieldGroupTemplateMutation,
  DeleteParticipantFieldGroupTemplateMutationVariables,
} from '../types';

export const useDeleteParticipantFieldGroupTemplateMutation = (
  options?: MutationOptions<
    DeleteParticipantFieldGroupTemplateMutation,
    DeleteParticipantFieldGroupTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantFieldGroupTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantFieldGroupTemplates'),
      });
    },
  });
};
